import { useState, useCallback, useEffect, useRef } from 'react';
import isEmpty from 'lodash/isEmpty';
import { Value } from 'slate';

export const emptyValue = {
  document: {
    nodes: [
      {
        object: 'block',
        type: 'paragraph',
        nodes: [
          {
            object: 'text',
            text: '',
          },
        ],
      },
    ],
  },
};


const useSlateValue = initialValue => {
  const [value, setValue] = useState(() => Value.fromJSON(isEmpty(initialValue) ? emptyValue : initialValue));
  const previousValues = useRef([null, null]);
  const [hasValueChanged, setHasValueChanged] = useState(false);

  useEffect(() => {
    setValue(Value.fromJSON(isEmpty(initialValue) ? emptyValue : initialValue));
  }, [initialValue]);

  const handleChange = useCallback(({ value }) => {
    setValue(value);

    const currentValue = value.toJSON();
    currentValue.data = null;
    currentValue.selection = null;
    if (!previousValues.current || !previousValues.current[0]) {
      previousValues.current = [JSON.stringify(currentValue), JSON.stringify(currentValue)];
    } else {
      previousValues.current[1] = JSON.stringify(currentValue);
    }

    setHasValueChanged(previousValues.current[0] !== previousValues.current[1]);
  }, []);

  const resetHasValueChanged = useCallback(() => {
    const currentValue = value.toJSON();
    currentValue.data = null;
    currentValue.selection = null;
    previousValues.current = [JSON.stringify(currentValue), JSON.stringify(currentValue)];

    setHasValueChanged(previousValues.current[0] !== previousValues.current[1]);
  }, [value]);

  return [value, handleChange, hasValueChanged, resetHasValueChanged];
};

export default useSlateValue;
